import React, { useEffect , useState }  from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import MyCard,{SecondCard} from './ChildComponent';


function Carrossel() {

  const [data, setData] = React.useState([]);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let slider1 = null;
  let slider2 = null;



  useEffect(() => {
    // Faça uma chamada à API e armazene os dados de resposta no estado do componente
    fetch('https://api.github.com/users/MaxwellAt/repos')
      .then(response => response.json())
      .then(data => {
        const filteredData = data.filter(item => item.homepage !== '' && item.homepage !== null);
        setData(filteredData);
      });

  }, []);

  useEffect(()=>{
    setNav1(slider1);
    setNav2(slider2);
  },[slider1,slider2])

  var settings = {
    infinite: true,
    slidesToShow: 1,
    speed: 500,
    adaptiveHeight:true,
    autoplay:true,
    autoplaySpeed:1700
  };


  return (
    <div style={{width: "74vw",margin: "auto"}}>
      <Slider asNavFor={nav2} ref={slider => (slider1 = slider)} style={{width: "90%",margin: "auto"}} {...settings}>
        {data.map(item => (
          <MyCard p={true} className='card' key={item.id - item.id} data={item} />
        ))}
      </Slider>
      <Slider
      className='Dots'
      asNavFor={nav1}
      ref={slider => (slider2 = slider)}
      slidesToShow={3}
      swipeToSlide={true}
      focusOnSelect={true}
      style={{width: "90%",margin: "auto"}}
      adaptiveHeight={false}
      >
        {
          data.map((item) => (
            <SecondCard p={false} key={item.id} data={item} />
          ))
        }

      </Slider>
    </div>
  );
}
export default Carrossel;